export { default } from "./getAccessibilityControlsParagraphCount";
